/**
 * Registry 代理
 * @public
 */
class ProxyRegistry {
    constructor(registry) {
        this.registry = registry;
        this.forEach = (callbackfn, thisArg) => this.registry.forEach(callbackfn, thisArg);
    }
    get(target) {
        return this.registry.get(target);
    }
    set(target, provider) {
        this.registry.merge(target, provider);
        return this;
    }
    has(target) {
        return this.registry.has(target);
    }
    get size() {
        return this.registry.size;
    }
}

export { ProxyRegistry };
//# sourceMappingURL=proxy-registry.js.map
